import { FactoryBase } from '../../interfaces';
import { PropertyTranslationResponse } from '../interfaces/property-translation.response';
import { PropertyTranslation } from '../models/property-translation.model';
// @dynamic
export class PropertyTranslationFactory implements FactoryBase<PropertyTranslation> {
  // This function exists, because this is used in a model.
  // @dynamic
  public static loadFromResponse(response: PropertyTranslationResponse[]): PropertyTranslation[] {
    return response.map(translation => new PropertyTranslation(translation));
  }
  // @dynamic
  public loadFromResponse(response: PropertyTranslationResponse[]): PropertyTranslation[] {
    return response.map(translation => new PropertyTranslation(translation));
  }
}
